import React from 'react';
import classNames from 'classnames';
import { useWindowSize } from 'usehooks-ts';

type StepIndicatorProps = {
  currentStep: number;
  totalSteps: number;
};

const StepIndicator = ({ currentStep, totalSteps }: StepIndicatorProps) => {
  const steps = Array.from({ length: totalSteps }, (_, index) => index + 1);
  const { width } = useWindowSize();
  const isMobile = width <= 768;

  return (
    <div className="flex items-center gap-1 md:flex-col md:gap-2">
      {steps.map(step => {
        const isLastStep = step === totalSteps;
        const isCompleted = step < currentStep;
        const isCurrentStep = step === currentStep;
        const stepStatus = isCompleted ? 'completed' : isCurrentStep ? 'active' : 'default';

        const activeMobile = stepStatus === 'active' && isMobile;
        const defaultMobile = stepStatus === 'default' && isMobile;
        const completedMobile = stepStatus === 'completed' && isMobile;

        const activeNotMobile = stepStatus === 'active' && !isMobile;
        const defaultNotMobile = stepStatus === 'default' && !isMobile;
        const completedNotMobile = stepStatus === 'completed' && !isMobile;

        return (
          <React.Fragment key={step}>
            <div
              className={classNames(
                'inline-flex size-6 flex-col items-center justify-center rounded-full text-xs font-bold md:size-[30px] md:text-lg',
                {
                  'bg-[#221D20] text-[#6F6C90]': stepStatus === 'default',
                  'bg-[#9937F7] text-white': stepStatus !== 'default',
                }
              )}
            >
              {step}
            </div>
            {!isLastStep && (
              <div
                className={classNames(
                  'relative h-1 w-16 rounded-sm bg-[#221D20] after:absolute after:inset-0 after:h-full after:w-full after:origin-left after:rounded-sm after:bg-[#9937F7] after:transition md:h-[156px] md:w-1 md:after:origin-top',
                  {
                    'after:scale-y-100': completedNotMobile,
                    'after:scale-y-0': defaultNotMobile,
                    'after:scale-y-50': activeNotMobile,
                    'after:scale-x-100': completedMobile,
                    'after:scale-x-0': defaultMobile,
                    'after:scale-x-50': activeMobile,
                  }
                )}
              ></div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepIndicator;
